import type { GoalListResponse } from '@lmc/ts-common'
import type { GetBaseOptions } from 'api/requestsTypes/get'
import { getJSON } from 'common/services/api'
import type { LMCRequest as LmcRequest } from './types'

const list: LmcRequest<
  { result: GoalListResponse[] },
  { anyStatus: boolean },
  GetBaseOptions
> = (residentId) => getJSON({ url: `/api/list/residents/${residentId}/goals` })

const fetch: LmcRequest<
  { result: GoalListResponse },
  { residentID: string; goalID: string },
  GetBaseOptions
> = ({ params }) => {
  return getJSON({
    url: `/api/list/residents/${params.residentID}/goals/${params.goalID}`
  })
}

export const goalsRequests = {
  list,
  fetch
}
